// 会员类型
export const VIP_TYPE = {
    VIP: 0, // vip
    SVIP: 1, // svip
    FREE: 2, // 免费版
    TRIAL: 7, // 体验版
    COMPANY: 10, // 企业会员
}